<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('couponDetail.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="couponDetailManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="couponDetailManageInfo.conditions.couponName"
                :placeholder="$t('couponDetail.enterCouponName')"
                clearable
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="couponDetailManageInfo.conditions.createTime"
                type="daterange"
                :placeholder="$t('couponDetail.selectPurchaseTime')"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="_queryCouponDetailMethod"
            >
              <i class="el-icon-search"></i>
              {{ $t('common.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('couponDetail.purchaseRecord') }}</div>
      </div>
      <div class="">
        <coupon-detail-manage-table
          :coupon-details="couponDetailManageInfo.couponDetails"
        />
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="couponDetailManageInfo.total"
          :page-size="couponDetailManageInfo.conditions.row"
          :current-page="couponDetailManageInfo.conditions.page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listCouponDetail } from '@/api/goods/couponDetailApi'
import CouponDetailManageTable from '@/components/goods/couponDetailManageTable.vue'

export default {
  name: 'CouponDetailManage',
  components: {
    CouponDetailManageTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      couponDetailManageInfo: {
        couponDetails: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          couponName: '',
          createTime: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.shopId = getShopId()
    this.couponDetailManageInfo.conditions.shopId = this.shopId
    this._listCouponDetails(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    console.log(this.couponDetailManageInfo.moreCondition)
  },
  methods: {
    handleSizeChange(val) {
      this.couponDetailManageInfo.conditions.row = val
      this._listCouponDetails(
        this.couponDetailManageInfo.conditions.page,
        val
      )
    },
    handleCurrentChange(val) {
      this._listCouponDetails(val, this.couponDetailManageInfo.conditions.row)
    },
    async _listCouponDetails(_page, _rows) {
      this.couponDetailManageInfo.conditions.page = _page
      this.couponDetailManageInfo.conditions.row = _rows
      try {
        const res = await listCouponDetail(this.couponDetailManageInfo.conditions)
        this.couponDetailManageInfo.total = res.total
        this.couponDetailManageInfo.records = res.records
        this.couponDetailManageInfo.couponDetails = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryCouponDetailMethod() {
      this._listCouponDetails(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>